export default __webpack_public_path__ + "static/media/knife-edge.c5f0fac3.webp";